import { PayOnline } from "../components/home/PayOnline";

export default function Pay() {
  return (
    <main data-testid="pay-page" className="pt-20 md:pt-24">
      <PayOnline />
    </main>
  );
}
